<template>
    <div class="wa-collapse" role="tablist" aria-multiselectable="true">
        <slot></slot>
    </div>
</template>

<script setup lang="ts">
import { useVModel } from "@vueuse/core";
import { COLLAPSE_KEY } from "./collapse.core";
import { useAnimation } from "./animation";
/**实现功能 */
let props = defineProps<{ accordion?: boolean; modelValue: string }>();
let emit = defineEmits(["change"]);
const tabs = ref([]);
const activeName = useVModel(props, "modelValue");

provide(COLLAPSE_KEY, {
    activeName,
    tabs,
    emit(name: string) {
        emit("change", name);
    },
});

useAnimation(activeName, tabs);
</script>
